import { usePublicLoyalty } from "@/hooks/usePublicLoyalty";

export default function RedeemPoints() {
  const { config } = usePublicLoyalty();
  const stats = [
    { label: "Minimum redemption", value: `${Number(config?.min_redeem_points || 0)} pts` },
    { label: "Value per point", value: `₹${Number(config?.burn_ratio || 0)}` },
    { label: "Standard validity", value: `${Number(config?.point_expiry_days || 0)}d` },
  ];
  return (
    <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20" data-testid="page-redeem">
      <div className="text-[11px] uppercase tracking-[0.3em] kazo-text-burgundy mb-4">REDEEM</div>
      <h1 className="editorial-headline text-5xl lg:text-7xl mb-12">Use them<br /><em className="font-light">your way.</em></h1>
      <div className="bg-white border border-black/10 p-12 grid md:grid-cols-3 gap-10 text-center">
        {stats.map((stat) => <div key={stat.label}><div className="font-display text-5xl kazo-text-burgundy mb-2" data-testid={`redeem-${stat.label.toLowerCase().replace(/\s+/g, "-")}`}>{stat.value}</div><div className="text-xs uppercase tracking-widest text-neutral-500">{stat.label}</div></div>)}
      </div>
      <div className="mt-12 text-neutral-700 max-w-3xl space-y-4"><p>Use your registered mobile number at checkout. Redemption security and coupon stacking follow the active programme rules.</p></div>
    </div>
  );
}